/*
|--------------------------------------------------------------------------
| Views: Featured Gallery
|--------------------------------------------------------------------------
*/

/**
 * Featured Gallery
 * @namespace
 */
__gh__webApp.views.featuredGallery = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	}

};